<template>
  <div class="support-panel">
    <div class="support-panel-header">
      <div>{{ t('do_you_have_question') }}</div>
      <div>{{ t('chat_us') }}</div>
    </div>
    <SupportChannels :order="order" @chat="emits('chat')"/>
    <a class="support-panel-faq" :href="faqUrl" target="_blank">
      {{ t('faq') }}
      <UiIcon :icon="ChevronRightIcon" :size="24"/>
    </a>
  </div>
</template>

<script setup lang="ts">
import {computed} from 'vue';
import {UiIcon} from '@ismet/vue-ui-kit';

import {useI18n, getHelpCenterLocale} from '@/shared/lib/i18n';
import {getB2bOrigin} from '@/shared/lib/utils/environment';

import ChevronRightIcon from '@/shared/ui/icons/navigation/ChevronRight.vue';

import SupportChannels from './SupportChannels.vue';
import type {SupportChannel} from '../model/types';

interface IProps {
  order?: SupportChannel[];
}

interface IEmits {
  (e: 'chat'): void;
}

defineProps<IProps>();
const emits = defineEmits<IEmits>();

const {t, locale} = useI18n();

const faqUrl = computed(() =>
    `${getB2bOrigin()}/${getHelpCenterLocale(locale.value)}/spravochny-tsentr/chasto-zadavaemye-voprosy`
);
</script>

<style scoped>
.support-panel {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}

.support-panel-header {
  display: flex;
  flex-direction: column;
  font-weight: 600;
  font-size: 1rem;
}

.support-panel-faq {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.25rem 0.5rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  color: var(--BW-800);
  text-decoration: none;

  &:hover {
    background: var(--BW-100);
  }
}
</style>

<i18n lang="json">
{
  "ru": {
    "do_you_have_question": "Есть вопрос?",
    "chat_us": "Напишите нам в чат",
    "faq": "Часто задаваемые вопросы"
  },
  "kk": {
    "do_you_have_question": "Сұрағыңыз бар ма?",
    "chat_us": "Бізге чат арқылы жазыңыз",
    "faq": "Жиі қойылатын сұрақтар"
  },
  "en": {
    "do_you_have_question": "Do you have a question?",
    "chat_us": "Chat with us",
    "faq": "Frequently asked questions"
  }
}
</i18n>
